import { CommonModule } from "@angular/common";
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { IButtonToggleItem } from "src/app/common/components/button-toggle/button-toggle.component";
import { ButtonToggleModule } from "src/app/common/components/button-toggle/button-toggle.module";
import { SelectModule } from "src/app/common/components/form/select/select.module";
import { SelectOptionItem } from "src/app/common/components/select/select.interface";
import { SLOT } from "src/app/common/enums/slot";
import { ContentfulContentType } from "src/app/core/interfaces/contentful";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";
import { ChipSetComponent, ChipSetConfig } from "src/app/shared/ui/chip-set/chip-set.component";
import { TextFieldComponent } from "src/app/shared/ui/form-fields/text-field/text-field.component";
import { TabConfig, TabsComponent } from "src/app/shared/ui/tabs/tabs.component";
import { TableFilterComponent } from "src/app/slots/three-year-plan/common/components/table/components/table-filter/table-filter.component";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "tpm-contentful-wrapper-navigation",
  templateUrl: "./contentful-wrapper-navigation.component.html",
  styleUrls: ["./contentful-wrapper-navigation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ButtonToggleModule,
    SelectModule,
    TextFieldComponent,
    EneButtonModule,
    TabsComponent,
    ChipSetComponent
  ]
})
export class ContentfulWrapperNavigationComponent implements OnDestroy, AfterContentInit {
  @ViewChild("filterRef") public readonly filterRef!: TableFilterComponent;

  @Output() public readonly searchChange = new EventEmitter<string>();
  @Output() public readonly moduleChange = new EventEmitter<Array<SLOT>>();
  @Output() public readonly contentTypeChange = new EventEmitter<ContentfulContentType>();

  @Input() public isMobileView: boolean;
  @Input() public moduleSelectOptions: Array<SelectOptionItem>;
  @Input() public contentType: ContentfulContentType;
  @Input() public contentTypeToggles: Array<IButtonToggleItem>;
  @Input() public useChipSet: boolean;

  private readonly destroy$ = new Subject<void>();
  public selectedModule: string | undefined;

  private _activeModuleFilters: Array<string> = [];

  public get moduleChips(): Array<ChipSetConfig> {
    return (this.moduleSelectOptions ?? []).map(({ label, value }) => ({
      label,
      value: value ?? ""
    }));
  }

  public activeFilters(): Array<string> {
    return this._activeModuleFilters;
  }

  public get contentTypeTabs(): Array<TabConfig<ContentfulContentType>> {
    return (this.contentTypeToggles ?? []).map(({ label, value, disabled }) => ({
      name: value as ContentfulContentType,
      label,
      disabled
    }));
  }

  public onContentTypeChange(contentType: ContentfulContentType): void {
    this.filterRef?.reset();
    this.contentTypeChange.emit(contentType);
  }

  public onModuleChipsChange(values: Array<string>): void {
    this._activeModuleFilters = values;
    this.selectedModule = values[0] || null;

    const slots = values.filter(Boolean) as Array<SLOT>;
    this.moduleChange.emit(slots);
  }

  public onSearchChange(search: string): void {
    this.searchChange.emit(search?.toLowerCase()?.trim());
  }

  public ngAfterContentInit(): void {
    if (this.moduleSelectOptions && this.moduleSelectOptions.length > 0) {
      this.selectedModule = this.moduleSelectOptions[0].value;
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
